import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import SeparatedList from '@/components/SeparatedList';

interface TalentContactInfoProps {
  email?: string;
  phone?: string;
  idNumber?: string;
}

const TalentContactInfo: FC<TalentContactInfoProps> = ({ email, phone, idNumber }) => {
  const { t } = useTranslation(['talents']);
  const fields = useMemo(
    () =>
      [
        email && { value: email, key: 'email' },
        phone && { value: phone, key: 'phone' },
        idNumber && { value: `${t('layouts.talents.columns.idNumber')}: ${idNumber}`, key: 'idNumber' }
      ].filter(Boolean) as Array<{ value: string; key: string }>,
    [email, phone, idNumber, t]
  );

  return (
    <SeparatedList
      alignItems="center"
      gap={1}
      separator={
        <Typography variant="body2" color="grey.500">
          |
        </Typography>
      }
    >
      {fields.map(field => (
        <Typography variant="body3" color="grey.800" key={field.key}>
          {field.value}
        </Typography>
      ))}
    </SeparatedList>
  );
};

export default TalentContactInfo;
